import { ContactsApiProvider } from './contactsapi.services';

export const fetchNotifications = (memberKey) => {
  return ContactsApiProvider.get(`/members/${memberKey}/notificationlogs`);
};

export const updateNotificationAsRead = (id) => {
  return ContactsApiProvider.put(`/notifications/${id}`);
};

export const fetchNotificationCount = (memberKey) => {
  return ContactsApiProvider.get(`/members/${memberKey}/notificationscount`);
};
